"use client";

import Image from "next/image";
import { useState } from "react";
import { forceImgReloadOnError } from "@/helpers/forceImgReloadOnError";
import clsx from "clsx";

export default function VideoSwitcher({
  imageSrc,
  embedSrc,
  length,
  isVideo,
  videoSrc,
  className,
  iframeClassName,
  imageClassName
}: {
  imageSrc?: string;
  embedSrc: string;
  length?: string;
  isVideo?: boolean;
  videoSrc?: string;
  className?: string;
  iframeClassName?: string;
  imageClassName?: string;
}) {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div
      className={clsx([
        "rounded-lg md:w-[800px] xl:shrink-0 w-full h-full relative aspect-video overflow-hidden outline outline-1 outline-white/8 -outline-offset-1",
        className,
      ])}
    >
      {!showVideo ? (
        <>
          {isVideo ? (
            <video
              src={videoSrc}
              controls={false}
              autoPlay
              loop
              muted
              className="md:w-[800px] aspect-video w-full h-full object-cover absolute inset-0 outline outline-1 outline-white/8 -outline-offset-1 rounded-lg"
            />
          ) : (
            <Image
              src={imageSrc ?? "/images/pages/migrated/30d08a55cbed5860dbfea627da3dfea10d3b3780-1666x1200.jpg"}
              width={880}
              height={660}
              alt={"Image with a video length of " + length + "min"}
              onError={forceImgReloadOnError}
              className={imageClassName}
            />
          )}
          <button
            onClick={() => setShowVideo(true)}
            className="flex gap-3 group absolute bottom-2 left-2 pr-6 items-center bg-white/12 backdrop-blur-md p-2 rounded"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="group-hover:scale-105 transition-all"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM14.2467 10.9148L21.0932 14.8785C21.7935 15.2839 21.7935 16.295 21.0932 16.7004L14.2467 20.6642C13.545 21.0705 12.6667 20.5641 12.6667 19.7532V11.8257C12.6667 11.0149 13.545 10.5085 14.2467 10.9148Z"
                fill="white"
              />
            </svg>
            <div className="flex flex-col leading-none gap-1.5 text-sm font-medium">
              <span>Play video</span>
              {length && <span className="opacity-50">{length} min</span>}
            </div>
          </button>
        </>
      ) : (
        <iframe
          src={embedSrc}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className={clsx(["md:w-[800px] w-full aspect-video md:relative absolute inset-0",
            iframeClassName
          ])}
        ></iframe>
      )}
    </div>
  );
}
